const routes = {
  path: "/formularios",
  component: () => import("./Module.vue"),
  children: [
    {
      path: "cabrero-cargador",
      name: "FormularioCabreroCargador",
      component: () => import("./views/CabreroCargador.vue"),
      meta: { public: true },
    },
  ],
};

export default routes;
